import { useState, useEffect } from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import SharedIDModal from "./SharedIDModal";
import api from "services/api";

import { useTranslation } from "react-i18next";

import bgImage from "assets/images/bg-user-info.jpg";
import appStoreImg from "assets/images/clients/app-store.png";

function UserHero() {
  const { t } = useTranslation();

  const [software, setSoftware] = useState(null);
  const [sharedOpen, setSharedOpen] = useState(false);
  const appStoreUrl =
    software?.public_download_url ||
    software?.download_url ||
    (software?.items || []).find((item) => item.package_type === "app_store")
      ?.public_download_url ||
    "";

  useEffect(() => {
    api
      .get("/software/ios/")
      .then((res) => {
        setSoftware(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <MKBox
      minHeight="52vh"
      width="100%"
      sx={({ breakpoints }) => ({
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        [breakpoints.down("md")]: {
          paddingTop: "6rem",
          paddingBottom: "6rem",
        },
      })}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              textAlign: "center",
              mt: { xs: 2, md: 0 },
            }}
          >
            <MKTypography variant="h4" color="white" fontWeight="bold">
              {software?.name || t("clients.ios.softwareName")} for iOS & iPadOS {/* 软件名称 */}
            </MKTypography>

            <MKTypography variant="body2" color="white" opacity={0.8} mt={1}>
              {t("clients.ios.supportedDevices")} {/* 适用设备 */}
            </MKTypography>

            <MKTypography variant="body2" color="white" opacity={0.8} mt={0.5}>
              {t("clients.ios.currentVersionLabel")}:{" "}
              {software?.version || t("clients.ios.version")}
            </MKTypography>
            <MKBox mt={2} display="flex" flexWrap="wrap" justifyContent="center" gap={1.5}>
              <MKButton
                variant="outlined"
                color="white"
                size="small"
                onClick={() => setSharedOpen(true)}
                sx={{
                  fontSize: "0.8rem",
                  padding: "0 12px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {t("clients.ios.getSharedAppleId")}
              </MKButton>
              <a
                href={appStoreUrl || "#"}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  opacity: appStoreUrl ? 1 : 0.5,
                  pointerEvents: appStoreUrl ? "auto" : "none",
                }}
              >
                <img src={appStoreImg} alt="Download on the App Store" style={{ height: "40px" }} />
              </a>
            </MKBox>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              mt: { xs: 4, md: 0 },
            }}
          >
            <MKTypography variant="h5" color="white" fontWeight="bold">
              {t("clients.ios.usage.title")} {/* 使用说明标题 */}
            </MKTypography>

            <MKTypography variant="body2" color="white" opacity={0.85} mt={1}>
              1. {t("clients.ios.usage.step1")}{" "}
              <MKTypography
                component="span"
                variant="body2"
                color="white"
                fontWeight="bold"
                onClick={() => setSharedOpen(true)}
                sx={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  ml: 0.5,
                }}
              >
                查看详情
              </MKTypography>
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.85} mt={0.5}>
              2. {t("clients.ios.usage.step2")}
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.85} mt={0.5}>
              3. {t("clients.ios.usage.step3")}
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.85} mt={0.5}>
              4. {t("clients.ios.usage.step4")}
            </MKTypography>

            <SharedIDModal open={sharedOpen} onClose={() => setSharedOpen(false)} />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default UserHero;
